import { apiSlice } from './api-slice';
import {
  AuthConfiguration,
  LoginData,
  Login,
  Response,
  UserDetails,
  VerifyAccountData,
  ResetPasswordRequest,
} from '../models';

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUserDetails: builder.query<Response<UserDetails>, void>({
      query: () => ({
        url: 'company/teamMember/getUserDetails',
        method: 'GET',
      }),
    }),
    getAuthConfiguration: builder.query<Response<AuthConfiguration>, void>({
      query: () => ({
        url: 'configuration/AUTHENTICATION',
        method: 'GET',
      }),
    }),
    login: builder.mutation<Response<Login>, LoginData>({
      query: data => ({
        url: 'company/authenticate/login',
        method: 'POST',
        body: data,
      }),
    }),
    forgetPassword: builder.mutation<Response<string>, { email: string }>({
      query: data => ({
        url: 'company/authenticate/forgetPassword',
        method: 'POST',
        body: data,
      }),
    }),
    verifyAccount: builder.mutation<
      Response<VerifyAccountData>,
      { email: string; otp: string }
    >({
      query: data => ({
        url: 'company/authenticate/verifyAccount',
        method: 'POST',
        body: data,
      }),
    }),
    resetPassword: builder.mutation<Response<string>, ResetPasswordRequest>({
      query: data => ({
        url: 'company/authenticate/resetPassword',
        method: 'POST',
        body: data,
      }),
    }),
    verifyToken: builder.query<Response<null>, string>({
      query: token => ({
        url: `company/teamMember/verifyToken`,
        method: 'GET',
        params: {
          token,
        },
      }),
    }),
    setNewPassword: builder.mutation<
      Response<null>,
      { password: string; activationToken: string }
    >({
      query: data => ({
        url: 'company/teamMember/setNewPassword',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetUserDetailsQuery,
  useGetAuthConfigurationQuery,
  useLoginMutation,
  useResetPasswordMutation,
  useVerifyAccountMutation,
  useForgetPasswordMutation,
  useVerifyTokenQuery,
  useSetNewPasswordMutation,
} = authApiSlice;
